module.exports = __webpack_public_path__ + "static/media/Pasted Graphic 11.87f57fec.png";